<mat-toolbar color="primary">
  <mat-toolbar-row>
    <div class="header-top-left">
      <div class="header-logo">
        <img src="images/logo_cn.svg" alt="CN One" />
        <span class="head-text">One</span>
      </div>
    </div>
    <div class="header-top-right">
      <div class="header-cart">
        <div class="top-panel-right help" [matMenuTriggerFor]="menu2" (click)="onAccountMenu()">
          <button mat-icon-button>
            <img class="nav-icon" src="images/help.svg" alt="help" />            
          </button>
          <span class="right-menu-content"> {{'help' | translate}}</span>
          <img class="drop-icon vector-icon" src="images/Vector.svg" alt="vector" />
        </div>
        <div class="top-panel-right user-account" [matMenuTriggerFor]="menu1" (click)="onAccountMenu()">
          <button mat-icon-button >
            <img class="nav-icon" src="images/User-Profile-Icon.svg" alt="profile" />            
          </button>
          <span class="right-menu-content">{{userName}}</span>
          <img class="drop-icon vector-icon" src="images/Vector.svg" alt="vector" />
        </div>
      </div>
    </div>
  </mat-toolbar-row>
  <mat-toolbar-row class="shell-ship-toolbar">
    <nav class="header-nav">
      <ul class="header-menu">
        @if(isOrderTabEnabled) {
          <li><a mat-button routerLink="/orders" routerLinkActive="active">{{'order_management' | translate}}</a></li>
        }        
        <li><a mat-button routerLink="/shipments" routerLinkActive="active">{{'shipment_tracking' | translate}}</a></li>
      </ul>
      <!-- <button mat-button class="create-order-btn" (click)="navigateToCreateOrder()"><img class="add-icon" src="images/add.svg" alt="create-order" /> <span>{{'create_order' | translate}}</span></button> -->
    </nav>
  </mat-toolbar-row>
</mat-toolbar>


<mat-menu class="cn-menu-popover" [overlapTrigger]="false" #menu1 [id]="'menu1'"> 
  <ul class="pop-over-menu">
    <li class="li-menu-item">
      <div class="welcome">{{'profile_menu.welcome' | translate}}</div><div class="user-name">{{userName}}</div></li>
    <li class="li-menu-item">{{'profile_menu.request_tools' | translate}}</li>
    <li class="li-menu-item">{{'profile_menu.tpa' | translate}}</li>
    <li class="li-menu-item" (click)="openExternalScreen('profile')">{{'profile_menu.profile' | translate}}</li>
    <li class="li-menu-item log-out-menu" (click)="logout()"> <img class="nav-icon" src="images/log-out.svg" alt="profile" /> <span class="log-out">{{'profile_menu.log_out' | translate}}</span></li>
  </ul>
</mat-menu>

<mat-menu class="cn-menu-popover cn-menu-popover-info" [overlapTrigger]="false" #menu2 [id]="'menu2'"> 
  <ul class="pop-over-menu">
    <li class="info-menu-item" (click)="openExternalScreen('support')">{{'help_menu.support_center' | translate}}</li>
    <li class="info-menu-item" (click)="openExternalScreen('contact')">{{'help_menu.contact_me' | translate}}</li>
  </ul>
</mat-menu>